// extracted by mini-css-extract-plugin
module.exports = {"invoiceNote":"InvoiceInfo_invoiceNote__SWYyY"};